import { createRoute } from '@tanstack/react-router';
import { adminParentRoute } from 'pages/admin/adminParentRoute';
import { zodPathParamId } from 'routes/routeUtils';
import { z } from 'zod';

export const adminClaimRelaunchPlanEditRoute = createRoute({
  getParentRoute: () => adminParentRoute,
  path: '/claim_relaunch_plans/$id/edit',
  params: z.object({ id: zodPathParamId }),
}).lazy(() =>
  import(
    'pages/admin/ClaimRelaunchPlans/AdminClaimRelaunchPlanEditPage/AdminClaimRelaunchPlanEditPage'
  ).then((d) => d.Route)
);
